import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import PlanIcon from '#components/svg/icons/NavVersetzungsplan'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import StyledText from '#components/a/StyledText'
import {routeKeys} from '#config/routeKeys'

export class UpcommingChangeInAbteilungBenachrichtigungAusbilder extends React.PureComponent {
  onClickNotification = () => {
    const {onNotificationClick} = this.props
    onNotificationClick(routeKeys.ablaufundtermine)
  }

  render() {
    const {userInfo} = this.props
    const text = i18n.t('notification_text_will_change_abteilung_ausbilder', [
      `${userInfo.lastname}, ${userInfo.firstname}`,
    ])

    return (
      <button type="button" className="notification" onClick={this.onClickNotification}>
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={text} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <PlanIcon />
        </div>
      </button>
    )
  }
}

UpcommingChangeInAbteilungBenachrichtigungAusbilder.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(UpcommingChangeInAbteilungBenachrichtigungAusbilder, ['senderId'])
